var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_15678",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.350586,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_15678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0034 12.0814C12.4485 12.0814 12.8285 11.9229 13.1432 11.6058C13.458 11.2888 13.6153 10.9077 13.6153 10.4626C13.6153 10.0174 13.4568 9.63744 13.1398 9.32271C12.8228 9.00796 12.4417 8.85059 11.9966 8.85059C11.5514 8.85059 11.1714 9.00909 10.8567 9.32611C10.542 9.64311 10.3846 10.0242 10.3846 10.4694C10.3846 10.9146 10.5431 11.2945 10.8601 11.6092C11.1771 11.924 11.5582 12.0814 12.0034 12.0814ZM12 20.0275C13.8794 18.3916 15.3653 16.7278 16.4577 15.0362C17.55 13.3445 18.0961 11.8814 18.0961 10.6467C18.0961 8.81725 17.5169 7.30732 16.3586 6.11694C15.2003 4.92655 13.7474 4.33136 12 4.33136C10.2525 4.33136 8.79964 4.92655 7.64131 6.11694C6.48298 7.30732 5.90381 8.81725 5.90381 10.6467C5.90381 11.8814 6.44996 13.3445 7.54226 15.0362C8.63457 16.7278 10.1205 18.3916 12 20.0275ZM12 21.3698C9.64996 19.2916 7.87977 17.3535 6.68938 15.5554C5.499 13.7573 4.90381 12.1211 4.90381 10.6467C4.90381 8.53135 5.59259 6.78648 6.97016 5.41211C8.34771 4.03776 10.0243 3.35059 12 3.35059C13.9756 3.35059 15.6522 4.03776 17.0298 5.41211C18.4073 6.78648 19.0961 8.53135 19.0961 10.6467C19.0961 12.1211 18.5009 13.7573 17.3105 15.5554C16.1202 17.3535 14.35 19.2916 12 21.3698Z",
    fill: "#B8B9BA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.d8a57299cc506ffd7123caa57fb82ca1.svg";
export { ForwardRef as ReactComponent };